import React from 'react';
import { useStore } from '@nanostores/react';

import {InputWidget, RadioMultiSelectWidget} from "../../controls/widgets.jsx";

import { $specializationsDict } from '../../stores/Dictionaries.jsx';
import NavBtnWidget from '../NavBtnWidget.jsx';


export default ({schema, data, onDataChanged}) => {
    const 
        me = this,
        //
        onDataChangedEventHandler = (value, key) => {
            let diff = {};
            diff[key] = value;
            (onDataChanged || function(){})(diff)
        },
        //
        specializations = useStore($specializationsDict);

    return (
        <form className="form">
            <div className="card border-primary">
                <div className="card-header text-bg-primary">
                    Общие сведения
                </div>
                <div className="card-body form-horizontal">
                    <InputWidget
                        name="full_name"
                        title="Ваше полное имя:"
                        placeholder="например, Иванов Иван Иванович"
                        schema={schema}
                        data={data}
                        onChange={onDataChangedEventHandler.bind(me)}
                    />
                    <InputWidget
                        type="tel"
                        name="contact_phone"
                        title="Контактный телефон:"
                        subtitle="Рекомендуется указывать номер, привязанный к MAX"
                        placeholder="в любой форме, например 8 980 123 45 67"
                        schema={schema}
                        data={data}
                        onChange={onDataChangedEventHandler.bind(me)}
                    />
                </div>
            </div>

            <div className="card border-primary mt-2">
                <div className="card-header text-bg-primary">
                    Направления подготовки
                </div>
                <div className="card-body">
                    <p className="text-justify">
                        Выберите одно или несколько интересующих Вас направлений подготовки по очереди
                        в порядке от наиболее к наименее предпочтительным. Количество направлений ограничено&nbsp;&mdash;
                        можно выбрать только три.
                    </p>
                    <p className="text-justify">
                        <em>Цифра обозначает установленный приоритет.</em>
                    </p>
                    <div className="col-lg-12 trit-specials">
                        <RadioMultiSelectWidget
                            name="specialization"

                            items={
                                _.filter(
                                    specializations,
                                    (a) => (typeof a == 'object') && (a.closed !== true)
                                )
                            }

                            render_cb={(v, k, ch, id) => (
                                <>
                                    <label htmlFor={id} className="index">
                                        {ch||<>&nbsp;</>}
                                    </label>
                                    <label htmlFor={id}>
                                        <div className="spec-line1">
                                            {v.title}
                                        </div>
                                        <div className="spec-line2">
                                            {v.url?<>Описание: <a target="_blank" href={v.url}>описание</a></>:null}
                                        </div>
                                        <div className="spec-line2">
                                            {v.numPlaces?<><strong>Кол-во мест:</strong>{v.numPlaces}</>:null}
                                        </div>
                                        <div className="spec-line2">
                                            {v.avgGrade?<><strong>Ср.балл:</strong>{v.avgGrade}</>:null}
                                        </div>

                                        {v.tgtt.length>0
                                        ?<div className="spec-tgt-education">
                                            <strong>Целевое обучение:</strong>
                                            {_.map(v.tgtt, (vv,  kk) => (
                                                <div key={kk} className="spec-tgt-el">{vv.orgName}</div>
                                            ))}
                                        </div>
                                        :null
                                        }   
                                    </label>
                                </>
                            )}
                        
                            value_cb={(v) => (v !== undefined ? v.id : null)}

                            schema={schema}
                            data={data}
                            onChange={onDataChangedEventHandler}
                        />
                    </div>
                </div>
            </div>

            <NavBtnWidget to="/docs" />

        </form>
    );
}
